import { Primitive } from '../../../types/blocks/Primitive';

const VideoBlock: Primitive = {
  name: 'VideoBlock',
  friendlyName: 'Video',
  isInput: false,
  isPrimitive: true,
  isAvailableInEditor: true,
  tags: ['Media'],
  properties: {
    video: {
      type: 'Video',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};

export default VideoBlock;
